<template>

    <CarouselCard :interval="0" ref="carouselCardRef" :initialIndex="initial_index" type="card" height="400px" arrow="always" @change="changeHandle">
      
      <CarouselCardItem v-for="item in items" :key="item._pk">

        <div v-if="!item.pro_pk_plan">
         <v-card elevation="24" color="orange">
          <v-card-title class="item__title__category">
            {{item.prc_code}}
          </v-card-title>
          <v-card-text class="mt-5 d-inline-block mx-auto text-center">
            <v-btn v-if="item.prc_sub_count>0" @click="refresh_item_category(item.prc_pk)" :disabled="!item.prc_active" class="category__button">{{ $t('buttons.category_catalog') }}</v-btn>
            <v-btn v-else @click="refresh_item_product(item.prc_pk)" :disabled="!item.prc_active" class="plan__button">{{ $t('buttons.plans_catalog') }}</v-btn>
            <div v-if="item.prc_level>1" class="back__button__category">
                <v-btn
                type="button"
                rounded
                class="primary"
                @click="return_to_parent()"
                :disabled="!item.prc_active"
                >
                {{ $t('buttons.back_catalog') }}
                </v-btn>
            </div>
          </v-card-text>
          <v-card-text class="item__content__category">
            {{item.prc_name}}
          </v-card-text>
            </v-card>
        </div>

         <v-card v-if="item.pro_pk_plan" :class="v_card_classes(item)" outlined>
            <v-card-title class="item__title__plan">
               {{item.pro_name_plan}}
            </v-card-title>
            <v-card-subtitle class="item__subtitle__plan">
               <center>
                  {{ $n(item.pro_price_plan,'currency') }}<br/>
                  <span class="item__subtitle__plan__small">{{ $t('utils._BP_pm') }}</span>
               </center>
            </v-card-subtitle>
            <v-card-text class="my-auto d-inline-block mx-auto text-center">
               <center>
                  ({{$n(item.pro_monthly_threshold_plan)}} {{ $t('texts.emails_per_month') }})
                  <br/>
                  <br/>
                  <div v-for="addon in item.pro_addons" :key="addon._pk" >
                     <b-checkbox v-model="addon.pro_addon_checked" onchange="update_cart(addon,item._pk)" :disabled="addon.pro_addon_checked">
                        {{ addon.pro_name }}<span v-if="addon.pro_price>0" class="item_addon_checkbox"> (+{{ $n(addon.pro_price,'currency') }})</span>
                     </b-checkbox>
                  </div>
                  <br/>
                  <!--<div class="back__button__plan">
                     <v-btn
                     type="button"
                     rounded
                     class="primary"
                     @click="return_to_parent()"
                     >
                     {{ $t('buttons.back_catalog') }}
                     </v-btn>
                  </div>-->
                  <div class="button__order__product">
                     <v-btn @click="add_to_cart(item)" :disabled="item._index!=initial_index" class="order__button">{{ $t('buttons.order_catalog') }}</v-btn>
                  </div>
                  <hr/>
                  <div>
                     <img :src="item.pro_image_link_plan" class="plan__photo" width="80%">
                  </div>
                  <!--<div class="item__content__plan" v-html="item.pro_html_content_product">
                  {{item.pro_html_content_product}}
                  </div>-->
               </center>
            </v-card-text>
         </v-card>
      </CarouselCardItem>

    </CarouselCard>
 
</template>

<script>

import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import { CarouselCard, CarouselCardItem } from 'vue-carousel-card'
import 'vue-carousel-card/styles/index.css'

export default {

   name: 'catalog',
   
   components: {
      Vue,
      i18n,
      CarouselCard,
      CarouselCardItem
      
   },

   props: {
      callbacks: {},
      options: {
         type: Array,
         default: function() {
            return [];
         }
      },
   },

   data: () => {
      return {
        items: [],
        initial_index: 0,
        last_parent: null,
        isDisplay: false,
      }
   },

  async mounted () {
      if ( this.$route.query.prc_pk_parent!=null ) {
        await this.refresh_item_category(this.$route.query.prc_pk_parent);
      } else if (this.$route.query.prc_code_parent!=null ) {
        await this.refresh_item_category(this.$route.query.prc_code_parent,'code');
      } else if ( this.$route.query.pro_code!=null ) {
        await this.refresh_item_product(this.$route.query.pro_code,'code');
      } else {
        await this.refresh_item_category();
      }
   },

  methods: {

   changeHandle(value) {
      this.initial_index = value;
      if ( this.callbacks && this.callbacks.onchange ) {
         this.callbacks.onchange(this.items[value]);
      }
   },

   v_card_classes(item) {
      return ( item._index==this.initial_index ? "item__card__plan__active" : "item__card__plan" )
   },

    async return_to_parent() {
      // console.log('return_to_parent, last_parent='+this.last_parent);
      await this.refresh_item_category(this.last_parent);
    },

   async refresh_item_category(key=null,code=null) {
      console.log('refresh_item_category, key='+key+', code='+code)
      if ( this.callbacks.oninit ) { this.callbacks.oninit(key); }
      if ( key!=null && code==null) {
         var row = this.$api._get_by_pk(this.items,key);
         if ( row!=null ) {
            this.last_parent = row.prc_pk_parent;
         } else {
            this.last_parent = null;
         }
      }
      // console.log('refresh_item_category0, last_parent='+this.last_parent);

      if ( key==null ) {
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'productcategory?search={"prc_level": 1,"prc_visible_on_front": true }');
      } else if ( code!=null ) {
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'productcategory?search={"prc_code_parent": "'+key+'","prc_visible_on_front": true }');
      } else {
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'productcategory?search={"prc_pk_parent": '+key+',"prc_visible_on_front": true }');
      }
      console.log('refresh_item_category1, api_response='+JSON.stringify(api_response));
      this.items = api_response.rows;

      for (let i = 0; i < this.items.length; i++) {
         if (this.items[i].prc_default == true){
            this.initial_index = i;
            break;
         } 
      }

      if ( this.initial_index>=0 ) {
         this.changeHandle(this.initial_index);
      }

      // console.log('refresh_item_category3, last_parent='+this.last_parent);
   },

    async refresh_item_product(key,code=null) {
         console.log('refresh_item_product, key='+key+', items='+JSON.stringify(this.items))
         if ( this.callbacks.oninit ) { this.callbacks.oninit(key); }
         if ( key!=null && code==null) {
            var row = this.$api._get_by_pk(this.items,key);
            if ( row!=null ) {
               this.last_parent = row.prc_pk_parent;
            }
            // console.log('refresh_item_product0, last_parent='+this.last_parent);
         } else {
            this.last_parent = null;
            // console.log('refresh_item_product0else, last_parent='+this.last_parent);
         }
      
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,'productcategory/'+key+'/plans');
         // console.log('refresh_item_product1, api_response='+JSON.stringify(api_response));
         this.items = api_response.rows;

         for (let i = 0; i < this.items.length; i++) {
            this.items[i]._index = i;
            if (this.items[i].pro_default_plan == true){
               this.initial_index = i;
            }
            if ( this.items[i].pro_addons) {
               for ( var j=0;j<this.items[i].pro_addons.length;j++ ) {
                  this.items[i].pro_addons[j].pro_addon_checked = this.items[i].pro_addons[j].pro_addon_auto_included;
               }
            }
         }

         if ( this.initial_index>=0 ) {
            this.changeHandle(this.initial_index);
         }

        // console.log('refresh_item_product3, last_parent='+this.last_parent);
      },

      add_to_cart(item) {
         if ( this.callbacks.oncart ) {
            this.callbacks.oncart(item,this.options);
         }
      },

      update_cart(addon,_pk) {
         console.log('update_cart, _pk='+_pk+', addon='+JSON.stringify(addon))
      }
  }
}
</script>

<style>

/*Desktop-----------------------------------------------------------------------------*/

@media screen { 

   .carousel-card-arrow {
      background-color: #6f42c1; /* #6f42c1 */ /* #c17542 */
      font-size: 30px;
   }

   .item__title__plan, .item__subtitle__plan {
      text-align: center !important;
      justify-content: center !important;
   }

   .order__button {
      font-size: 0.85em !important;
      font-weight: bold;
   }

/*Card*/

   .item__card__plan {
      background-color: #f8fcd2 !important;
   }

   .item__card__plan__active {
      background-color: #e5e9a8 !important;
   }

/*Arrow */

   .carousel-card-arrow {
      font-size: 30px;
   }

}

@media screen and (width > 750px) { 

   .item__title__plan {
      font-size: 2.6em !important;
   }
   .item__subtitle__plan {
      font-size: 2.6rem !important;
      padding-top: 20px !important;
   }
   .item__subtitle__plan__small {
      font-size: 1rem !important;
   }

}

@media screen and (width <= 750px) { 

   .item__title__plan {
      font-size: 1.5rem !important;
   }
   .item__subtitle__plan {
      font-size: 1.5rem !important;
      padding-top: 5px !important;
   }
   .item__subtitle__plan__small {
      font-size: 0.6rem !important;
   }

}
</style>